import React, { useCallback } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton from "../common/IconButton";
import Logo from "../common/Logo";
import {
  faBars,
  faMoon,
  faRightFromBracket,
  faSun,
} from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import { useUnsavedChanges } from "../hooks/useUnsavedChanges";
import { useThemeMode } from "../contexts/themeMode";

type Props = {
  className?: string;
  showSidebar?: VoidFunction;
};

export default function AppNavbar({ className, showSidebar }: Props) {
  const location = useLocation();
  const { safeNavigate } = useUnsavedChanges();
  const { mode, toggle } = useThemeMode();

  const handleSidebarToggle = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    showSidebar?.();
  };

  const handleLogout = useCallback(() => {
    Cookies.remove(window.__env.AUTH_TOKEN_NAME || "coaching-master-token");
    Cookies.remove(
      window.__env.AUTH_REFRESH_TOKEN_NAME || "coaching-master-refresh-token"
    );
    window.location.reload();
  }, []);

  const handleBrandClick = useCallback(() => {
    safeNavigate("/");
  }, [safeNavigate]);

  return (
    <Navbar
      className={classNames(
        "app-navbar d-flex flex-row align-items-center shadow-sm border-bottom",
        className
      )}
    >
      {![
        "/privacy-policy",
        "/conferma-registrazione",
        "/termini-e-condizioni-d-uso",
        "/domande-frequenti",
        "/contattaci",
      ].includes(location.pathname) && (
        <IconButton className="mx-2 ms-3" onClick={handleSidebarToggle}>
          <FontAwesomeIcon size="xl" className="text-white" icon={faBars} />
        </IconButton>
      )}

      <span style={{ cursor: "pointer" }} onClick={handleBrandClick}>
        <Navbar.Brand>
          <Logo height={70} className="d-inline-block align-top px-md-3" logo={require("../assets/img/LOGO CLAUDIO MESSINA_MONOGRAMMA PNG_MONOGRAMMA BIANCO-05.png")} />
        </Navbar.Brand>
      </span>

      <Nav className="flex-row align-items-center ms-auto">
        <IconButton
          onClick={toggle}
          tooltip={mode === "dark" ? "Tema chiaro" : "Tema scuro"}
        >
          <FontAwesomeIcon
            color="#FFF"
            size="lg"
            className="me-3"
            icon={mode === "dark" ? faSun : faMoon}
          />
        </IconButton>
        <IconButton onClick={handleLogout}>
          <FontAwesomeIcon
            color="#FFF"
            size="lg"
            className="me-3"
            icon={faRightFromBracket}
          />
        </IconButton>
      </Nav>
    </Navbar>
  );
}
